import { render } from "./LiveRoundInformation.vue?vue&type=template&id=b3764b56&scoped=true"
import script from "./LiveRoundInformation.vue?vue&type=script&lang=js"
export * from "./LiveRoundInformation.vue?vue&type=script&lang=js"

import "./LiveRoundInformation.vue?vue&type=style&index=0&id=b3764b56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3764b56"]])

export default __exports__